var testiCarousalV2 = (function () {
  return {
    init: init,
  };

  function init() {

    window.addEventListener("resize", resSlider);

    resSlider();
  }

  function resSlider() {
    var slider = new bstackSlider({
      selector: ".testi-caro-container",
      cssClass: [],
      showDots: true,
      gap: {
        1300: 40,
        980: 40,
        640: 40,
        320: 40
      }
    });
  }
})();

window.addEventListener("load", function () {
  testiCarousalV2.init();
});
